<template>
  <CustomSelect
    class="w-100"
    inputId="rolePicker"
    inputLabel="نقش کاربر"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="rolesList"
  ></CustomSelect>
</template>
<script>
export default {
  emits: ["getSelectedRole"],
  props: {
    defaultSelectedRoleId: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    this.getAllRoles();
    if (this.defaultSelectedRoleId) {
      this.selectedRole = this.defaultSelectedRoleId;
    }
  },
  watch: {
    selectedRole: {
      handler(val) {
        this.$emit("getSelectedRole", val);
      },
    },
  },
  data() {
    return {
      rolesList: [],
      selectedRole: null,
    };
  },

  methods: {
    async getAllRoles() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUserTypes = new GetAllUserTypes(_this);
        await getAllUserTypes.fetch(
          function (response) {
            response.forEach((item) => {
              _this.rolesList.push({
                text: item.title,
                value: item.userTypeId,
              });
            });
            if (!_this.defaultSelectedRoleId) {
              _this.rolesList.unshift({
                text: "انتخاب کنید",
                value: null,
                selected: true,
                disabled: true,
              });
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import { GetAllUserTypes } from "@/libs/Api/UserType";
</script>
